import * as Sentry from "@sentry/react"
import App from "./App"
import { Provider } from "react-redux"
import ReactDOM from "react-dom/client"
import ReactGA from "react-ga4"
import { inDevelopMode } from "utils/env"
import { currentEnvironment } from "configs/environment"
import reportWebVitals from "./reportWebVitals"
import store from "store"
import "./i18n/i18n"

!inDevelopMode &&
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    release: process.env.REACT_APP_RELEASE,
    environment: currentEnvironment,
    org: process.env.REACT_APP_SENTRY_ORG,
  })

const root = ReactDOM.createRoot(document.getElementById("root"))

!inDevelopMode &&
  ReactGA.initialize([
    {
      trackingId: process.env.REACT_APP_GA_MEASUREMENT_ID,
      gaOptions: { debug_mode: true },
      gtagOptions: { debug_mode: true },
    },
  ])

root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

reportWebVitals()
